'use strict';

var $ = require('jquery');
var _ = require('underscore');
var Backbone = require('backbone');
var Radio = require('backbone.radio');
var moment = require('moment-timezone');
var Marionette = require('backbone.marionette');
var polyglot = require('../../utilities/polyglot').default;

var LoadingView = require('../loading').default;
var StaffView = require('../staff/select').default;
var WaitListView = require('../requests/form').default;
var GroupAppointmentListView = require('./list').default;
var AdvancedWaitListView = require('../requests/advanced-form').default;
var TimezonePickerModal = require('../timezone-picker/timezone-modal').default;
var TimeSelectionEvents = require('../../../analytics/time-selection-events').default;
var GroupAppointmentCollection = require('../../collections/group-appointments').default;
var TimezonePickerContainerView = require('../timezone-picker/timezone-container').default;

export default Marionette.View.extend({

  className: 'calendar',
  template: require('./templates/list.hbs'),

  shouldShowTimezonePopup: true,

  regions: {
    content: {
      el: ".group-appointment-list",
      replaceElement: true,
    },
  },

  ui: {
    staffPicker: '.adjust-select-width',
    timezone: '.timezone',
    timezone_picker: '.timezone-picker-container',
    timezone_select: '.timezone-select',
  },

  events: {
    'click .calendar-wait-list-link': 'onClickWaitList',
  },

  childViewEvents: {
    'hideLoadingView': 'hideLoadingView',
    'showLoadingView': 'showLoadingView',
  },

  initialize: function () {
    this.appointment = this.options.appointment;
    this.staff = this.options.staff;
    this.locations = this.options.locations;
    this.services = this.options.services;

    this.loadingView = new LoadingView();
    this.listView = new GroupAppointmentListView({
      collection: this.collection,
      appointment: this.appointment,
      staff: this.staff,
    });
    this.staffView = new StaffView({
      collection: window.SETTINGS.show_staff_picker ? this.staff : new Backbone.Collection(),
      selectedStaff: this.appointment.staff,
      childViewOptions: {
        collection: this.staff,
        selectedStaff: this.appointment.staff,
      },
    });

    this.displayStaffPicker = window.SETTINGS.show_staff_picker;

    this.setTimezone();

    if (this.displayStaffPicker) {
      this.listenTo(this.staffView, 'change:staff', this.onClickEmployee);
    }

    Radio.channel('timezone').off('change');
    Radio.channel('timezone').on('change', _.bind(this.onChangeTimezone, this));
  },

  onRender: function () {
    this.$el.prepend(this.loadingView.render().el);
    if (!window.SETTINGS.wait_list) {
      this.$el.addClass('no-wait-list');
    }
    if (this.displayStaffPicker) {
      this.ui.staffPicker.append(this.staffView.el);
      this.staffView.render();
    }
    this.showChildView('content', this.listView);
    this.listView.fetchTimes(this.appointment.staff || this.staff.first());

    this.timezoneSelect = this.ui.timezone_select.select2({
      templateSelection: this.buildSelectionContent,
      width: '100%',
    });
    this.timezoneSelect.on('select2:open', () => {
      $('.timezone .option-content i').removeClass('fa-chevron-down').addClass('fa-chevron-up');
    });
    this.timezoneSelect.on('select2:close', () => {
      $('.timezone .option-content i').removeClass('fa-chevron-up').addClass('fa-chevron-down');
    });
    this.timezoneSelect.on('select2:select', (event) => {
      const prevTimezone = window.localStorage.getItem('timezone');
      if (prevTimezone !== event.target.value) {
        window.localStorage.setItem('timezone', event.target.value);
        this.onChangeTimezone();
      }
    });
    this.timezoneSelect.val(window.localStorage.getItem('timezone'));
    this.timezoneSelect.trigger('change');
  },

  onChangeTimezone: function () {
    this.collection = new GroupAppointmentCollection(
      this.collection.adjustWithTimezone(this.appointment),
    );
    this.listView.setCollection(this.collection);
    this.listView.render();
  },

  buildSelectionContent: function (state) {
    if (!state.element) {
      return state.text;
    }

    const arrow = '<i class="fa fa-chevron-down"/>';

    return $(`<span class="option-content"><span class="name">${state.text}</span>${arrow}</span>`);
  },

  closeTimezonePicker: function () {
    this.ui.timezone.removeClass('open');
    this.ui.timezone_select.focus();
    this.ui.timezone_select.attr('aria-expanded', 'false');
    this.ui.timezone_picker.empty();
    this.ui.timezone_picker.hide();
  },

  setTimezone: function () {
    const { location } = this.appointment;
    const timezoneFromLocalStorage = window.localStorage.getItem('timezone');
    let timezone;

    if (location.isVirtual()) {
      timezone = timezoneFromLocalStorage || moment.tz.guess();
      const abbreviation = moment.tz(timezone).zoneAbbr();
      this.showTimezonePopup(timezone, abbreviation);
    } else {
      timezone = timezoneFromLocalStorage || location.getTimezone();
    }

    window.localStorage.setItem('timezone', timezone);
  },

  showTimezonePopup: function (timezone, abbreviation) {
    if (this.shouldShowTimezonePopup) {
      Radio.channel('toast').trigger('show', {
        message: polyglot.t('pages.times.timezone_select', {
          timezone,
          abbreviation,
        }),
        modalSize: 'small',
        icon: 'info-circle',
        buttonMessage: polyglot.t('messages.confirm'),
        skippable: false,
      });

      this.shouldShowTimezonePopup = false;
    }
  },

  onClickEmployee: function (model) {
    this.triggerMethod('change:staff', model);
  },

  serializeData: function () {
    const showStaffPicker = this.displayStaffPicker;

    return {
      doNotShowStaffPicker: !showStaffPicker,
      showStaffPicker,
      showWaitList: window.SETTINGS.wait_list && !window.SETTINGS.advanced_wait_list,
      timezones: window.TIMEZONES,
    };
  },

  fetchTimes: function (staff) {
    this.listView.fetchTimes(staff);
  },

  showLoadingView: function () {
    this.loadingView.show();
  },

  hideLoadingView: function () {
    this.loadingView.hide();
  },

  onClickWaitList: function (evt) {
    evt.preventDefault();

    if (window.SETTINGS.advanced_wait_list) {
      Radio.channel('modal').trigger('show', new AdvancedWaitListView({
        model: this.appointment.createRequest(),
        appointment: this.appointment,
        staff: this.staff,
      }));
    } else {
      Radio.channel('modal').trigger('show', new WaitListView({
        model: this.appointment.createRequest(),
        smsEnabled: this.appointment.isSmsEnabled(),
        locations: this.locations,
        services: this.services,
      }));
    }
  },
});
